module.exports = __webpack_public_path__ + "img/wd-icon.052a8455.png";